module.exports = __webpack_public_path__ + "static/media/mq.61a53cf5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mq.svg
// module id = 718
// module chunks = 0